<template>
	<div class="hidden lg:block w-50">
    <div class="flex items-center">
      <img src="@/assets/icons/value1.svg" class="w-10">
      <span class="pl-5">Qualified and Verified Manufacturers</span>
    </div>
    <div class="flex items-center pt-6">
      <img src="@/assets/icons/value2.svg" class="w-10">
      <span class="pl-5">Transparent Platform fees</span>
    </div>
    <div class="flex items-center pt-6">
      <img src="@/assets/icons/value3.svg" class="w-10">
      <span class="pl-5">Secure Payment</span>
    </div>
    <div class="flex items-center py-6">
      <img src="@/assets/icons/value4.svg" class="w-10">
      <span class="pl-5">End to End B2B Sourcing</span>
    </div>
    <div class="flex items-center py-5 border-t border-b border-dark-b">
      <img class="ml-1 w-10" src="@/assets/images/dollar.png">
      <div class="pl-7">
        Sell on Buyhive?
        <p class="text-yellowReg" v-if="forSupplierPreview">Register Now !</p>
        <a
          v-else
          target="_blank" class="text-yellowReg"
          :href="registerAsSupplier"
        >
          Register Now !
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	name: 'PromotionSection',
  data() {
    return {
      registerAsSupplier: process.env.VUE_APP_REGISTER_AS_SUPPLIER
    }
  },
  computed: {
    forSupplierPreview() {
      return this.$route.name === 'SupplierPreview' || this.$route.name === 'ProductPreviewForSupplier'
    }
  }
}
</script>